import React from 'react';
import VersionFooter from '../ui/VersionFooter';
import './Auth.css';

const defaultHighlights = [
  {
    label: 'Org-scoped access',
    text: 'CostPilot access is tied to Island Millwork identity and estimator workflows.',
  },
  {
    label: 'Microsoft-first',
    text: 'Production access is designed around Microsoft sign-in when the environment is configured for it.',
  },
  {
    label: 'Dev fallback',
    text: 'Local username and password flows stay available only for development work when Microsoft auth is not in play.',
  },
];

const AuthShell = ({
  eyebrow,
  title,
  description,
  helper,
  statusLabel,
  asideEyebrow = 'Estimator Access',
  asideTitle = 'Microsoft identity stays at the front door.',
  asideCopy = 'Use the same Island Millwork account that anchors your other org-managed tools whenever Microsoft access is available in this workspace.',
  highlights = defaultHighlights,
  children,
}) => {
  return (
    <div className="auth-shell">
      <div className="auth-shell__frame">
        <section className="auth-shell__panel" aria-label="Authentication panel">
          <div className="auth-shell__brand">
            <img
              src={`${process.env.PUBLIC_URL}/assets/app-logo.png`}
              alt="CostPilot"
              className="auth-shell__logo"
            />
            <div className="auth-shell__brand-copy">
              <span className="auth-shell__brand-name">CostPilot</span>
              <span className="auth-shell__brand-org">
                Island Millwork estimator workspace
              </span>
            </div>
          </div>

          <div className="auth-shell__content">
            <p className="auth-shell__eyebrow">{eyebrow}</p>
            <h1 className="auth-shell__title">{title}</h1>
            <p className="auth-shell__description">{description}</p>
            {helper ? <p className="auth-shell__helper">{helper}</p> : null}
            {statusLabel ? (
              <div className="auth-shell__status" aria-label="Authentication mode">
                {statusLabel}
              </div>
            ) : null}
            <div className="auth-shell__card">{children}</div>
          </div>

          <VersionFooter forceDisplay variant="auth" />
        </section>

        <aside className="auth-shell__aside" aria-label="Access overview">
          <p className="auth-shell__aside-eyebrow">{asideEyebrow}</p>
          <h2 className="auth-shell__aside-title">{asideTitle}</h2>
          <p className="auth-shell__aside-copy">{asideCopy}</p>

          <div className="auth-shell__highlight-list">
            {highlights.map((highlight) => (
              <div key={highlight.label} className="auth-shell__highlight">
                <p className="auth-shell__highlight-label">{highlight.label}</p>
                <p className="auth-shell__highlight-text">{highlight.text}</p>
              </div>
            ))}
          </div>
        </aside>
      </div>
    </div>
  );
};

export default AuthShell;
